import {
    Layout1, Layout10,
    Layout3, Layout6, Layout7, Layout8,
    LeftImageLayout,
    RightImageLayout
} from "../ui_library/ver_24.10/SlidesLayouts/SlideLayouts.comp";
import {
    Content2PointsWith1Image,
    Content3PointsWith1Image,
    Content3PointsWithNoImage,
    Content4PointsWithNoImage,
    ContentDescriptionWithNoImage,
    ContentSinglePointWith1Image,
    FinalSummary,
    IntroductionTitleWithGoals
} from "../ui_library/ver_24.10/SlidesLayouts/SlideLayoutsNew.comp";

export const CURRENT_VERSION = '1.10';

export const TOAST_TYPES = {
    DANGER: 'danger',
    WARN: 'warning',
    SUCCESS: 'success',
    INFO: 'info'
};

export const LOCAL_STORAGE_KEYS = {
    auth_token: 'dq_seal_cl_auth_token',
    auth_user: 'dq_seal_cl_auth_user',
    refresh_token: 'dq_seal_cl_refresh_token',
    user_email: 'dq_seal_cl_user_email',
    guest_fingerprint: 'guestFingerprint',
    user_fingerprint: 'userFingerprint',
    user_rating_fingerprint: 'userRatingFingerprint',
    user_desired_subscription_plan: 'userDesiredSubscriptionPlan',
    redirect_to_url: 'redirect_to_url',
}

export const SUBSCRIPTION_PLANS = {
    FREE: 'free',
    BASIC: 'basic',
    PLUS: 'plus',
    PRO: 'pro'
}

export const USER_ACCESS_LEVEL = {
    NOT_APPLICABLE: 0,
    NO_ACCESS: 1,
    PARTIAL_ACCESS_ADMIN_PORTAL: 2,
    FULL_ACCESS_ADMIN_PORTAL: 3,
    FULL_ACCESS_ANALYTICS_PORTAL: 4,
    PARTIAL_ACCESS_ANALYTICS_PORTAL: 5,
};

export const ACL_ENABLE_ENDPOINTS = []
export const URL_PERMS_MAP = {}

export const CHAT_TYPE = {
    BOT: 1,
    USER: 2
}

export const SEAL_TYPE = {
    ALIGN: 0,
    ENHANCE: 1,
    CERTIFY: 2
}

export const SEAL_TYPE_VERBOSE = {
    [SEAL_TYPE.ALIGN]: 'Aligned',
    [SEAL_TYPE.ENHANCE]: 'Enhanced',
    [SEAL_TYPE.CERTIFY]: 'Measured'
}

export const RATING_TYPE = {
    CPC_STARS_RATING: 1,
    DQ_RATING: 2,
}

export const RATING_TYPE_VERBOSE = {
    [RATING_TYPE.CPC_STARS_RATING]: 'DQ Stars Content Rating',
    [RATING_TYPE.DQ_RATING]: 'DQ Rating',
}

export const APP_STATUS = {
    DRAFT: 0,
    WITHDRAWN: 1,
    REJECTED: 2,
    PENDING_PAYMENT: 10,
    PENDING_APPROVAL: 20,
    IN_PROGRESS_COLLECT_DATA: 30,
    HALTED_COLLECT_DATA: 40,
    COLLECTED_DATA: 45,
    IN_PROGRESS_PROCESS_DATA: 50,
    HALTED_PROCESS_DATA: 60,
    PENDING_CLEANING: 65,
    IN_PROGRESS_LEVEL_MAPPING: 67,
    PENDING_REVIEW_MAPPING: 70,
    PENDING_ANALYSIS: 75,
    PENDING_REVIEW_REPORT: 80,
    HALTED_REPORT: 90,
    COMPLETED: 100,

    READY_TO_CERTIFY: 105,
    ADD_ASSESS_REQ_RECEIVED: 110,
    REQ_REVIEWED_ON_HOLD: 115,
    REQ_REVIEWED_REJECTED: 116,
    REQ_REVIEWED_PAYMENT_PENDING: 120,
    PAYMENT_RECEIVED_VER_PENDING: 130, // assessments & licenses cost.
    PAYMENT_DECLINE_ON_HOLD: 135,
    PAYMENT_DECLINE_REJECTED: 136,
    PAYMENT_CONFIRMED: 138,
    PENDING_AUTO_ASSESS_GENERATION: 140, // when approve from dq-certify bo, this status will be set.
    AUTO_ASSESS_GENERATION_IN_PROGRESS: 145,
    AUTO_ASSESS_GENERATION_HALTED: 150,
    AUTO_ASSESS_GENERATION_COMPLETED: 160, // in-progress review assessments
    PENDING_ASSESS_GENERATED_APPROVE: 162,
    PENDING_APPROVE_MODULES: 165,
    PENDING_PUBLISH_MODULES: 167,
    ASSESSMENTS_READY: 200,
    ASSESSMENTS_PUBLISHED: 210,

    // PBDQ-V3
    PROGRAM_DRAFT: 505,
    PROGRAM_DATA_SUBMITTED: 510,
    PROGRAM_SUMMARY_REPORT_IN_PROGRESS: 530,
    PROGRAM_SUMMARY_REPORT_HALTED: 535,
    PROGRAM_SUMMARY_REPORT_COMPLETED: 560,
    PROGRAM_FULL_REPORT_COMPLETED: 580,
}

export const APP_STATUS_VERBOSE = {
    [APP_STATUS.DRAFT]: 'Draft',
    [APP_STATUS.WITHDRAWN]: 'Withdrawn',
    [APP_STATUS.REJECTED]: 'Rejected',
    [APP_STATUS.PENDING_PAYMENT]: 'Pending Payment',
    [APP_STATUS.PENDING_APPROVAL]: 'Pending Approval',
    [APP_STATUS.IN_PROGRESS_COLLECT_DATA]: 'In Progress (collecting data)',
    [APP_STATUS.HALTED_COLLECT_DATA]: 'Halted (collecting data)',
    [APP_STATUS.COLLECTED_DATA]: 'Data Collected',
    [APP_STATUS.IN_PROGRESS_PROCESS_DATA]: 'In Progress (processing data)',
    [APP_STATUS.HALTED_PROCESS_DATA]: 'Halted (processing data)',
    [APP_STATUS.PENDING_CLEANING]: 'Pending Cleaning',
    [APP_STATUS.IN_PROGRESS_LEVEL_MAPPING]: 'In Progress (level mapping)',
    [APP_STATUS.PENDING_REVIEW_MAPPING]: 'Pending Review (mapping)',
    [APP_STATUS.PENDING_ANALYSIS]: 'Pending Analysis',
    [APP_STATUS.PENDING_REVIEW_REPORT]: 'Pending Review (report)',
    [APP_STATUS.HALTED_REPORT]: 'Halted (report)',
    [APP_STATUS.COMPLETED]: 'Assessment Available',

    [APP_STATUS.READY_TO_CERTIFY]: 'Completed',
    [APP_STATUS.ADD_ASSESS_REQ_RECEIVED]: 'Assessment In Development',
    [APP_STATUS.REQ_REVIEWED_ON_HOLD]: 'Assessment Req Halted',
    [APP_STATUS.REQ_REVIEWED_REJECTED]: 'Assessment Req Halted',
    [APP_STATUS.REQ_REVIEWED_PAYMENT_PENDING]: 'Assessment Req Payment Pending',
    [APP_STATUS.PAYMENT_RECEIVED_VER_PENDING]: 'Certify, Payment Verification Pending',
    [APP_STATUS.PAYMENT_DECLINE_ON_HOLD]: 'Certify, Payment halted',
    [APP_STATUS.PAYMENT_DECLINE_REJECTED]: 'Certify, Payment halted',
    [APP_STATUS.PAYMENT_CONFIRMED]: 'Certify, Payment Confirmed',
    [APP_STATUS.PENDING_AUTO_ASSESS_GENERATION]: 'Auto Assess Generate, Pending',
    [APP_STATUS.AUTO_ASSESS_GENERATION_IN_PROGRESS]: 'Auto Assess Generate, In-Progress',
    [APP_STATUS.AUTO_ASSESS_GENERATION_HALTED]: 'Auto Assess Generate, Halted',
    [APP_STATUS.AUTO_ASSESS_GENERATION_COMPLETED]: 'Auto Assess Generate, Completed',
    [APP_STATUS.PENDING_ASSESS_GENERATED_APPROVE]: 'Auto Assess Generated Review Pending',
    [APP_STATUS.PENDING_APPROVE_MODULES]: 'Pending Configure Modules',
    [APP_STATUS.PENDING_PUBLISH_MODULES]: 'Pending Publish Modules',
    [APP_STATUS.ASSESSMENTS_READY]: 'Assessment Ready to Preview',
    [APP_STATUS.ASSESSMENTS_PUBLISHED]: 'Assessment Published',

    // PBDQ-V3
    [APP_STATUS.PROGRAM_DRAFT]: 'Program Draft',
    [APP_STATUS.PROGRAM_DATA_SUBMITTED]: 'Program Data Submitted',
    [APP_STATUS.PROGRAM_SUMMARY_REPORT_IN_PROGRESS]: 'Report Analysis In Progress',
    [APP_STATUS.PROGRAM_SUMMARY_REPORT_HALTED]: 'Analysis of Program Halted. Please Try Again.',
    [APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED]: 'Summary Report Completed',
    [APP_STATUS.PROGRAM_FULL_REPORT_COMPLETED]: 'Report Available',
}

export const PROGRAM_STATUS = {
    DRAFT: 0,
    WITHDRAWN: 1,
    REJECTED: 2,
    IN_PROGRESS_COLLECT_DATA: 10,
    HALTED_COLLECT_DATA: 20,
    COLLECTED_DATA: 25,
    IN_PROGRESS_PROGRAM_CREATION: 30,
    PROGRAM_CREATED: 40,
    HALTED_PROGRAM_CREATION: 50,
    PENDING_OUTLINE_CREATION: 60,
    IN_PROGRESS_OUTLINE_CREATION: 65,
    OUTLINE_CREATED: 70,
    IN_PROGRESS_OUTLINE_UPDATE: 75,
    OUTLINE_COMPLETED: 80,
    PENDING_PAYMENT: 90,
    PENDING_APPROVAL: 100,
}

export const PROGRAM_STATUS_VERBOSE = {
    [PROGRAM_STATUS.DRAFT]: 'Program Creation Started',
    [PROGRAM_STATUS.WITHDRAWN]: 'Withdrawn',
    [PROGRAM_STATUS.REJECTED]: 'Rejected',
    [PROGRAM_STATUS.IN_PROGRESS_COLLECT_DATA]: 'Data Collection In Progress',
    [PROGRAM_STATUS.HALTED_COLLECT_DATA]: 'Halted',
    [PROGRAM_STATUS.COLLECTED_DATA]: 'Data Collected',
    [PROGRAM_STATUS.IN_PROGRESS_PROGRAM_CREATION]: 'Program Creation In Progress',
    [PROGRAM_STATUS.PROGRAM_CREATED]: 'Program Created',
    [PROGRAM_STATUS.HALTED_PROGRAM_CREATION]: 'Halted Program Creation',
    [PROGRAM_STATUS.PENDING_OUTLINE_CREATION]: 'Pending Outline Creation',
    [PROGRAM_STATUS.IN_PROGRESS_OUTLINE_CREATION]: 'Outline Creation In Progress',
    [PROGRAM_STATUS.OUTLINE_CREATED]: 'Outline Created',
    [PROGRAM_STATUS.IN_PROGRESS_OUTLINE_UPDATE]: 'Outline Update In Progress',
    [PROGRAM_STATUS.OUTLINE_COMPLETED]: 'Outline Completed',
    [PROGRAM_STATUS.PENDING_PAYMENT]: 'Pending Payment',
    [PROGRAM_STATUS.PENDING_APPROVAL]: 'Pending Payment Verification',
}

export const PBDQ3_PROGRAM_STATE = {
    PROGRAM_DRAFT: 5,
    OUTLINE_DRAFT: 10,
    OUTLINE_GENERATED: 20,
    CONTENT_DRAFT: 25,
    CONTENT_GENERATED: 25,
    PROGRAM_PUBLISHED: 50
}

export const PBDQ3_PROGRAM_STATE_VERBOSE = {
    [PBDQ3_PROGRAM_STATE.PROGRAM_DRAFT]: 'Program Draft',
    [PBDQ3_PROGRAM_STATE.OUTLINE_DRAFT]: 'Outlined Draft',
    [PBDQ3_PROGRAM_STATE.OUTLINE_GENERATED]: 'Outlined Generated',
    [PBDQ3_PROGRAM_STATE.CONTENT_DRAFT]: 'Content Draft',
    [PBDQ3_PROGRAM_STATE.CONTENT_GENERATED]: 'Content Generated',
    [PBDQ3_PROGRAM_STATE.PROGRAM_PUBLISHED]: 'Program Published',
}

export const PBDQ3_PROGRAM_SESSION_CONTENT_TYPE = {
    VIDEO: 'video',
    SLIDE: 'slide',
    ASSESSMENT: 'assessment',
    ACTIVITY: 'activity',
}

export const PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT = {
    VIDEO: 'Video',
    LEFT_IMAGE_SLIDE: 'LeftImageSlide',
    RIGHT_IMAGE_SLIDE: 'RightImageSlide',
    OPTIONS_SLIDE: 'OptionsSlide',
    STEPS_SLIDE: 'StepsSlide',
    SUMMARY_SLIDE: 'SummarySlide',
    TEXT_SLIDE: 'TextSlide',
    CHAT_SLIDE: 'ChatSlide',
    // New Layouts
    INTRO_TITLE_WITH_GOALS: "Introduction_title_with_goals",
    CONTENT_3_POINTS_WITH_NO_IMAGE: "content_3_points_with_no_image",
    CONTENT_4_POINTS_WITH_NO_IMAGE: "content_4_points_with_no_image",
    CONTENT_2_POINTS_WITH_1_IMAGE: "content_2_points_with_1_image",
    CONTENT_3_POINTS_WITH_1_IMAGE: "content_3_points_with_1_image",
    CONTENT_SINGLE_POINT_WITH_1_IMAGE: "content_single_point_with_1_image",
    CONTENT_DESCRIPTION_WITH_NO_IMAGE: "content_description_with_no_image",
    FINAL_SUMMARY: "final_summary"
}

export const PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT_VERBOSE = {
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.VIDEO]: Layout1,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.LEFT_IMAGE_SLIDE]: LeftImageLayout,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.RIGHT_IMAGE_SLIDE]: RightImageLayout,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.OPTIONS_SLIDE]: Layout3,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.STEPS_SLIDE]: Layout6,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.SUMMARY_SLIDE]: Layout7,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.TEXT_SLIDE]: Layout8,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.CHAT_SLIDE]: Layout10,

    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.INTRO_TITLE_WITH_GOALS]: IntroductionTitleWithGoals,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.CONTENT_3_POINTS_WITH_NO_IMAGE]: Content3PointsWithNoImage,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.CONTENT_4_POINTS_WITH_NO_IMAGE]: Content4PointsWithNoImage,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.CONTENT_2_POINTS_WITH_1_IMAGE]: Content2PointsWith1Image,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.CONTENT_3_POINTS_WITH_1_IMAGE]: Content3PointsWith1Image,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.CONTENT_SINGLE_POINT_WITH_1_IMAGE]: ContentSinglePointWith1Image,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.CONTENT_DESCRIPTION_WITH_NO_IMAGE]: ContentDescriptionWithNoImage,
    [PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT.FINAL_SUMMARY]: FinalSummary,
};

export const PAYMENT_STATUS = {
    // PENDING: 0,
    INITIALIZED: 1,
    PROCESSING: 2,
    SUCCESSFUL: 3,
    FAILED: 4,
    REFUNDED: 5
}

export const ASSESSMENT_REQ_TYPES = {
    PRE_SELECT_PRE_POST: 1,
    PRE_SELECT_POST_ONLY: 2,
    STANDARD_DCT: 3,
    STANDARD_DPT: 4,
    CUSTOM_PRE_POST: 5,
    CUSTOM_POST_ONLY: 6,
}